import { US_STATE_OPTIONS } from "@mimber/shared"
import { FieldValues, FieldPath } from "react-hook-form"
import { SelectField } from "../SelectField"
import type { StateFieldProps } from "./StateField.types"

/**
 * StateField wraps SelectField with a fixed dropdown of US
 * states/territories (2-letter USPS abbreviation as the value).
 */
export function StateField<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  name,
  control,
  label,
  required,
  help,
  placeholder = "Select a state",
  disabled,
  size,
  loading,
  allowClear = true,
}: StateFieldProps<TFieldValues, TName>) {
  return (
    <SelectField
      name={name}
      control={control}
      label={label}
      required={required}
      help={help}
      options={US_STATE_OPTIONS}
      placeholder={placeholder}
      disabled={disabled}
      size={size}
      loading={loading}
      showSearch
      filterOption={(input, option) =>
        (option?.label?.toString() ?? "")
          .toLowerCase()
          .includes(input.toLowerCase()) ||
        (option?.value?.toString() ?? "")
          .toLowerCase()
          .includes(input.toLowerCase())
      }
      allowClear={allowClear}
    />
  )
}
